
import { mapState } from 'vuex';
import formMixin from '~/services/form';
import skipSizesMixin from '~/mixins/skipSizes';

export default {
    name: 'InstantSkipQuotes',
    mixins: [formMixin, skipSizesMixin],
    props: {
        location: {
            type: Object,
            required: true,
        },
        radius: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            quotes: [],
            size: '4yd',
        };
    },
    async fetch() {
        if (!this.location.lat) {
            return;
        }
        const quotes = await this.$axios.$get(this.$config.endpoints.bidInstant, {
            params: {
                service_id: 2,
                size: this.size,
                lat: this.location.lat,
                lon: this.location.lon,
                radius: this.radius,
            },
        });
        this.quotes = quotes?.bids?.data || [];
    },
    computed: mapState(['services']),
    validations: {
        size: [],
    },
};
